import { Hero } from "../components/Hero";
import { AccreditationsMarquee } from "../components/AccreditationsMarquee";
import { ServicesBento } from "../components/ServicesBento";
import { Stats } from "../components/Stats";
import { SecurityQuiz } from "../components/SecurityQuiz";
import { IndustriesSection } from "../components/IndustriesSection";
import { RecruitmentPreview } from "../components/RecruitmentPreview";
import { CTABand } from "../components/CTABand";
import { ContactSection } from "../components/ContactSection";
import { useSEO } from "../lib/useSEO";

export default function HomePage() {
  useSEO({
    title: "UK Manned Guarding, CCTV, K9 Patrols & Security Systems",
    description: "SIA-licensed UK security company. Manned guarding, K9 patrols, CCTV tower hire, mobile patrols and 24/7 control room monitoring for construction sites, substations, industrial units and events.",
    keywords: "UK security company, manned guarding UK, SIA licensed security, K9 security patrols, CCTV tower hire, mobile patrols, construction site security, substation security, critical infrastructure security, 24/7 control room monitoring, private security UK, ACS approved contractor",
    path: "/",
  });
  return (
    <div data-testid="home-page">
      <Hero />
      <AccreditationsMarquee />
      <ServicesBento />
      <Stats />
      <SecurityQuiz />
      <IndustriesSection />
      <RecruitmentPreview />
      <CTABand />
      <ContactSection />
    </div>
  );
}
